var render = function (_h,_vm) {var _c=_vm._c;return _c('a',{directives:[{name:"track",rawName:"v-track:click",value:({ category: 'Outbound', label: _vm.props.href }),expression:"{ category: 'Outbound', label: props.href }",arg:"click"}],ref:"props.link",attrs:{"href":_vm.props.href}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }